import { supabase } from '@/lib/supabase';

export const getProfileId = async (userId: string, orgId: string) => {
  const { data, error } = await supabase.rpc('get_profile_id', {
    p_user_id: userId,
    p_org_id: parseInt(orgId),
  });
  if (error) throw error;
  return data;
};
